<template>
	<v-autocomplete
		:hide-details="hideDetails"
		:error="errorBorder"
		:error-messages="$props.error"
		:items="options"
		:label="$props.label"
		:multiple="true"
		:readonly="readonly"
		:clearable="clearable && !readonly"
		:disabled="disabled"
		:no-data-text="$t('labels.noData')"
		item-text="label"
		item-value="value"
		v-model="selectedValue"
	>
		<template v-slot:prepend-item>
			<v-list-item ripple @mousedown.prevent @click="toggle">
				<v-list-item-action>
					<v-icon :color="selectedAll || selectedSome ? 'primary' : ''">
						{{ icon }}
					</v-icon>
				</v-list-item-action>
				<v-list-item-content>
					<v-list-item-title> {{ $t('labels.selectAll') }}</v-list-item-title>
				</v-list-item-content>
			</v-list-item>
			<v-divider class="mt-2"></v-divider>
		</template>
		<template v-slot:selection="{ item, index }">
			<span v-if="index < 3">
				<span>{{ item.label }}{{ selectedValue.length - 1 > index && index < 2 ? ', ' : null }}&nbsp;</span>
			</span>
			<span v-if="index === 3" class="grey--text text-caption">
				(+{{ selectedValue.length - 3 }} {{ $t('labels.others') }})
			</span>
		</template>
		<template #prepend>
			<slot name="prepend"></slot>
		</template>
	</v-autocomplete>
</template>

<script>
export default {
	name: 'DropdownMultipleWithSelectAll',
	props: {
		readonly: Boolean,
		clearable: Boolean,
		disabled: Boolean,
		value: Array,
		ajax: Boolean,
		data: [Array, String],
		label: String,
		errorBorder: {
			type: Boolean,
			default: false,
		},
		error: {
			type: String,
			default: '',
		},
	},
	data() {
		return {
			endpoint: '',
			selectedValue: null,
			options: [],
			ajaxLoaded: false,
			protected: null,
		};
	},
	computed: {
		hideDetails() {
			return this.$props.error === '';
		},
		selectedAll() {
			if (this.selectedValue != null) {
				return this.selectedValue.length === this.options.length;
			} else {
				return false;
			}
		},
		selectedSome() {
			if (this.selectedValue != null) {
				return this.selectedValue.length > 0 && !this.selectedAll;
			} else {
				return false;
			}
		},
		icon() {
			if (this.selectedAll) return 'fa-square-check';
			if (this.selectedSome) return 'fa-square-minus';
			return 'far fa-square';
		},
	},
	watch: {
		value: function (newVal, oldVal) {
			if (newVal != oldVal) {
				if (newVal != this.selectedValue) {
					this.protected = newVal;
					this.setValue(newVal);
				}
			}
		},
		selectedValue: function (val) {
			if (val != this.$props.value) {
				if (val != null) {
					if (val != this.$props.value) {
						this.$nextTick(() => {
							this.$emit('input', val);
						});
					}
				} else {
					this.$nextTick(() => {
						this.$emit('input', null);
					});
				}
				this.$nextTick(() => {
					this.callChange();
				});
			}
		},
	},
	methods: {
		callChange() {
			this.$emit('changes');
		},
		toggle() {
			this.$nextTick(() => {
				if (this.selectedAll) {
					this.selectedValue = [];
				} else {
					this.selectedValue = this.options.flat().map((obj) => obj.value);
				}
			});
		},
		setValue(newVal) {
			if (this.$props.ajax) {
				var vm = this;
				this.$APICall(
					'get',
					'select/' + this.endpoint,
					{ protected: this.protected },
					(data, success) => {
						if (success) {
							vm.options = data;
							vm.ajaxLoaded = true;
							vm.selectedValue = newVal;
						}
					},
					false
				);
			} else {
				this.options = this.$props.data;
				this.selectedValue = newVal;
			}
		},
	},
	mounted() {
		if (this.$props.ajax) {
			this.endpoint = this.$props.data;
		}
		this.protected = this.$props.value;
		this.setValue(this.$props.value);
	},
};
</script>

<style scoped></style>
